import tw, { styled } from "twin.macro";

export const ListItem = styled.p(({ active }) => [
  tw`flex justify-start items-center cursor-pointer w-full px-4 py-1 first:pt-0 last:pb-0`,
  active && tw`bg-blue-300`,
]);
